import { combineReducers } from "redux";

import configurationReducer from "./configuration/configurationReducer";
import mstrSessionReducer from "./session/mstrSessionReducer";

const rootReducer = combineReducers({
  userDetails: mstrSessionReducer,
  configuration: configurationReducer,
});

export default rootReducer;
